interface Props {
  index: number;
  selected: boolean;
  onSelect: (index: number) => void;
}

export function InsertionSlot({ index, selected, onSelect }: Props) {
  return (
    <button
      type="button"
      className={`flex-shrink-0 w-5 h-12 sm:w-8 sm:h-32 rounded-full border-2 border-dashed transition-all focus-visible:outline focus-visible:outline-2 focus-visible:outline-orange-400 ${
        selected ? "border-orange-400 bg-orange-400/20 scale-110" : "border-violet-500/30 hover:border-violet-400/60"
      }`}
      aria-label={`Insérer en position ${index}`}
      aria-pressed={selected}
      onClick={() => onSelect(index)}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") onSelect(index);
      }}
    />
  );
}
